// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__nPgjR","pageNumber":"style_pageNumber__KVFb3","pageActive":"style_pageActive__UrCy3"};